import styled from 'styled-components';

import { gridSizes, media } from 'utils/style';

import RecurringOrderDetail from './RecurringOrderDetail';

export default styled(RecurringOrderDetail)`
  width: 70%;
  max-width: 900px;
  overflow-y: scroll;
  border-radius: ${gridSizes('M')};
  margin: 0 auto;
  padding: 0px 0px ${gridSizes('XL')} 0px;

  ${media.lessThan('medium')`
    width: 98%;
    `}

  .close {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;

    padding: ${gridSizes('S')};
    margin-top: -6px;
    cursor: pointer;
    display: flex;
    flex-direction: column;

    ${media.lessThan('extraSmall')`
    margin: inherit;
    justify-content: center;
    align-items: center;
    `};

    position: absolute;
    margin-top: ${gridSizes('M')};
    right: ${gridSizes('M')};
  }

  .recurring-summary-container {
    padding: ${gridSizes('L')};
    border-bottom: solid 1px var(--grey300);
    .summary-item {
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
      background-color: #ffffff;
      padding: 18px;
      .edit {
        display: none;
      }
    }
  }
  .aditional-options {
    background: #fff;
    padding: ${gridSizes('L')};
    margin-bottom: ${gridSizes('M')};
  }

  .feedbackbar-wrapper {
    background: #fff;
    border-top: solid 1px var(--grey300);
    padding: ${gridSizes('L')} ${gridSizes('L')} ${gridSizes('S')}
      ${gridSizes('L')};

    & > div {
      background: var(--primary100);
      border: 1px solid var(--primary300);
    }
  }
`;
